import { QueryClient } from "@tanstack/vue-query";
import { persistQueryClient } from "@tanstack/query-persist-client-core";
import { get, set, del } from "idb-keyval";

export const APP_CACHE_VERSION = "1.2.0";
const IDB_PERSIST_KEY = "shamudeen_vue_query_chapters_v2";
const TWENTY_FOUR_HOURS_MS = 24 * 60 * 60 * 1000;
const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      gcTime: TWENTY_FOUR_HOURS_MS,
      cacheTime: TWENTY_FOUR_HOURS_MS,
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

function createIdbPersister(idbValidKey = IDB_PERSIST_KEY) {
  return {
    persistClient: async (client) => {
      if (typeof indexedDB === "undefined") return;
      try {
        await set(idbValidKey, client);
      } catch (_e) {
        // Ignore IndexedDB quota/private mode errors
      }
    },
    restoreClient: async () => {
      if (typeof indexedDB === "undefined") return undefined;
      try {
        return await get(idbValidKey);
      } catch (_e) {
        return undefined;
      }
    },
    removeClient: async () => {
      if (typeof indexedDB === "undefined") return;
      try {
        await del(idbValidKey);
      } catch (_e) {
        // Ignore
      }
    },
  };
}

let persistenceInitialized = false;

export function initQueryPersistence() {
  if (persistenceInitialized || typeof indexedDB === "undefined") {
    return;
  }
  persistenceInitialized = true;
  try {
    persistQueryClient({
      queryClient,
      persister: createIdbPersister(),
      maxAge: SEVEN_DAYS_MS,
      buster: APP_CACHE_VERSION,
      dehydrateOptions: {
        shouldDehydrateQuery: (query) =>
          Array.isArray(query.queryKey) &&
          query.queryKey[0] === "chapter" &&
          query.state.status === "success",
      },
    });
  } catch (_e) {
    // Ignore persistence initialization errors in non-browser environments
  }
}
